import React from "react";

import Hero from "../sections/Hero";
import Meddical from "../sections/Meddical";
import Service from "../sections/Service";
import Specialties from "../sections/Specialties";
import Booking from "../sections/Booking";
import Doctors from "../sections/Doctors";
import News from "../sections/News";
import Contact from "../sections/Contact";

const Home = () => {
  return (
    <div className="home">
      <Hero />
      <Meddical />
      <Service />
      <Specialties />
      <Booking />
      <Doctors />
      <News />
      <Contact />
    </div>
  );
};

export default Home;
